import React from 'react';
import { Alert, Box, ModalClose, Typography } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { Icon } from '../../assets';
import DetailTitle from '../Detail/DetailTitle';

const DrawerPermissionDenied = ({ permission }) => {
    const { t } = useTranslation();

    return (
        <>
            <Box className="drawer-section-header">
                <ModalClose />
                <DetailTitle title={t('permission_denied')} />
            </Box>
            <Box
                className="drawer-section-content"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '50vh',
                    px: 3,
                    py: 4,
                    textAlign: 'center',
                }}
            >
                <Alert
                    color="warning"
                    variant="soft"
                    startDecorator={<Icon icon="faWarning" />}
                    sx={{ maxWidth: 480 }}
                >
                    {t('You are missing the permissions required to perform this action')}
                </Alert>
                {permission ? (
                    <Typography level="body-xs" sx={{ mt: 1.5, color: 'text.tertiary' }}>
                        {permission}
                    </Typography>
                ) : null}
            </Box>
        </>
    );
};

export default DrawerPermissionDenied;
